var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{attrs:{"label-position":"top"}},[_c('el-form-item',[_c('el-input',{attrs:{"readonly":true,"rows":27,"type":"textarea"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }